import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button, Checkbox, FlexColumn, FlexRow } from "@similarweb/ui-components";

export const AdvancedWrapper = styled.div`
    padding: 16px 24px;

    .title-error {
        input {
            caret-color: ${colorsPalettes.red["400_P"]};
        }
    }
`;

export const SubTitleWrapper = styled(FlexRow)`
    margin: 16px 0;
    justify-content: space-between;
`;

export const ListContainer = styled.div`
    border: 1px solid ${colorsPalettes.carbon[100]};
    border-radius: 4px;
`;

const CheckboxValueWrapper = styled(FlexRow)`
    position: relative;
    padding-left: 30px;
`;

const IconWrapper = styled.span`
    display: none;
    cursor: pointer;
`;

const StyledCheckbox = styled(Checkbox)<{ selected: boolean }>`
    display: ${({ selected }) => (selected ? "block" : "none")};
    position: absolute;
    left: 1px;
`;

const ListItem = styled(FlexRow)`
    align-items: center;
    justify-content: space-between;

    padding: 0 16px;
    box-sizing: border-box;

    &:hover {
        background: ${colorsPalettes.blue[50]};
        ${IconWrapper}, ${StyledCheckbox} {
            display: block;
        }
    }
`;

export const SelectExistingWrapper = styled(FlexRow)`
    padding: 8px 15px;
    background: ${colorsPalettes.bluegrey[100]};
    border-radius: 0 0 4px 4px;
    gap: 12px;
`;

export const Subtitle = styled.p`
    margin: 0;
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
`;

export const SubtitleCount = styled.p`
    margin: 0;
    ${setFontVariant("chip1", colorsPalettes.carbon[300])}
`;

export const FooterButtons = styled(FlexRow)`
    justify-content: space-between;
    padding: 0 16px 16px;
`;

export const StyledButton = styled(Button)`
    margin-left: 4px;
`;

export const TooltipContentWrapper = styled.span`
    display: block;
`;

export const LoaderContainer = styled(FlexColumn)`
    justify-content: center;
    gap: 40px;
    padding: 16px;
`;

export const LoadingText = styled(FlexRow)`
    justify-content: center;
    align-items: center;
    padding-bottom: 40px;

    ${setFontVariant("body2", colorsPalettes.carbon[300])};
`;

export const TitleError = styled.div`
    ${setFontVariant("caption", colorsPalettes.red["400_P"])};
`;
